import React, { useContext } from "react";
import axiosInstance from "../Axios";
import { useSelector, useDispatch } from "react-redux";

export async function GetQuestionByScenario(Qid, Sid, Lid, StoreRes, SetLoad) {
    SetLoad(true);
    try {
        const res = await axiosInstance.get(`/QuestionBank/GetScenarioQuestionByQuestionId?QuestionId=${Qid}&SubjectId=${Sid}&LanguageId=${Lid}`);
        StoreRes(res.data);
    }
    catch (error) {
        console.error("Error fetching questions:", error);
    }
    finally {
        SetLoad(false);
    }
}